import { useEffect, useRef } from 'react';

/**
 * Enables form export print styles (`form-summary-print-page` on `<html>`) and clears
 * `document.title` while printing so the browser header is cleaner.
 */
export const useFormExportPrintPage = (): void => {
  const documentTitleBeforePrintRef = useRef<string | null>(null);

  useEffect(() => {
    document.documentElement.classList.add('form-summary-print-page');

    const handleBeforePrint = () => {
      documentTitleBeforePrintRef.current = document.title;
      document.title = '';
    };
    const handleAfterPrint = () => {
      if (documentTitleBeforePrintRef.current !== null) {
        document.title = documentTitleBeforePrintRef.current;
        documentTitleBeforePrintRef.current = null;
      }
    };

    window.addEventListener('beforeprint', handleBeforePrint);
    window.addEventListener('afterprint', handleAfterPrint);

    return () => {
      document.documentElement.classList.remove('form-summary-print-page');
      window.removeEventListener('beforeprint', handleBeforePrint);
      window.removeEventListener('afterprint', handleAfterPrint);
      if (documentTitleBeforePrintRef.current !== null) {
        document.title = documentTitleBeforePrintRef.current;
        documentTitleBeforePrintRef.current = null;
      }
    };
  }, []);
};
